import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = {
  class: "app-header__inner",
  "aria-label": "Main navigation"
}
const _hoisted_3 = {
  key: 0,
  class: "app-navigation",
  "aria-label": "Platform sections"
}
const _hoisted_4 = { class: "app-header__actions" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "user-status__avatar",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "user-status__email" }
const _hoisted_8 = {
  id: "content",
  class: "app-content"
}

import { AButton, useThemeConfig } from '@adereso-ai/vue-components'
import AuthService from './services/AuthService/AuthService'
import EstablishmentService from './services/EstablishmentService/EstablishmentService'
import { User } from './services/AuthService/types'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useTheme } from 'vuetify'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const vuetifyTheme = useTheme()
const { theme: componentTheme } = useThemeConfig()

const isMounted = ref(false)
const currentUser = ref<User | undefined>(undefined)
const isDark = computed(() => vuetifyTheme.global.current.value.dark)
const userInitial = computed(() => currentUser.value?.email?.charAt(0).toUpperCase() || 'A')
const currentPath = computed(() => router.currentRoute.value.path)
const isAccountsRoute = computed(() => currentPath.value.startsWith('/whatsapp-business-accounts'))

onMounted(async () => {
  componentTheme.value = isDark.value ? 'dark' : 'light'
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  watch(authService.currentUser, (newCurrentUser) => {
    currentUser.value = newCurrentUser
  })
  isMounted.value = true
})

function toggleTheme () {
  const nextTheme = isDark.value ? 'light' : 'dark'
  vuetifyTheme.global.name.value = nextTheme
  componentTheme.value = nextTheme
  window.localStorage.setItem('adereso-bsp-theme', nextTheme)
  document.documentElement.style.colorScheme = nextTheme
}

async function signOut () {
  // remove token from local storage
  const authService = await AuthService.getInstance()
  authService.signOut()
  const establishmentService = await EstablishmentService.getInstance()
  establishmentService.removeCurrentEstablishment()
  router.push('/')
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "bsp-app" }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "app-brand" }, [
            _createElementVNode("a", {
              class: "app-brand__logo",
              href: "https://adereso.ai",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": "Go to the Adereso website"
            }, [
              _createElementVNode("img", {
                src: "/adereso-icon.svg",
                class: "app-brand__icon",
                alt: "",
                "aria-hidden": "true"
              }),
              _createElementVNode("span", { class: "app-brand__wordmark" }, "adereso")
            ]),
            _createElementVNode("span", {
              class: "app-brand__divider",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", { class: "app-brand__product" }, [
              _createElementVNode("small", null, "WhatsApp Business"),
              _createElementVNode("strong", null, "BSP Platform")
            ])
          ], -1)),
          (currentUser.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(AButton), {
                  color: isAccountsRoute.value ? 'blue' : 'base',
                  variant: isAccountsRoute.value ? 'tonal' : 'text',
                  size: "small",
                  "prepend-icon": "tabler:brand-whatsapp",
                  to: "/whatsapp-business-accounts"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" Accounts ", -1)
                  ]))]),
                  _: 1
                }, 8, ["color", "variant"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (currentUser.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "user-status",
                  title: currentUser.value.email
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(userInitial.value), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(currentUser.value.email), 1)
                ], 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createVNode(_unref(AButton), {
              icon: isDark.value ? 'tabler:sun' : 'tabler:moon',
              variant: "text",
              size: "small",
              "help-text": isDark.value ? 'Use light theme' : 'Use dark theme',
              "aria-label": isDark.value ? 'Use light theme' : 'Use dark theme',
              onClick: toggleTheme
            }, null, 8, ["icon", "help-text", "aria-label"]),
            (currentUser.value)
              ? (_openBlock(), _createBlock(_unref(AButton), {
                  key: 1,
                  color: "red",
                  variant: "text",
                  size: "small",
                  "prepend-icon": "tabler:logout",
                  onClick: signOut
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Sign out ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_8, [
        (isMounted.value)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})